import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Label,
  FormGroup,
  Input,
  ButtonGroup,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faCamera,
  faCloudUploadAlt,
  faTimes,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import "../../../scss/dashboard/lawyers.scss";
import useFileUpload from "../../../api/hooks/useFileUpload";
import { toast } from "react-toastify";
function ImageUploade({ isOpen, closeModal, handleSubmitPic }) {
  const [selectedImage, setSelectedImage] = useState(null);
  const [imgURL, setImgURL] = useState("");
  const [isImageValid, setIsImageValid] = useState(false);

  const handleCancel = () => {
    closeModal();
    setTimeout(() => {
      setSelectedImage(null);
    }, 300);
  };

  useEffect(() => {
    if (selectedImage !== null) {
      if (selectedImage?.size / 1024 ** 2 <= 5) {
        setIsImageValid(true);
        console.log(selectedImage);
      } else if (selectedImage?.size / 1024 ** 2 >= 5) {
        console.log(selectedImage);
        setIsImageValid(false);
      }
    }
  }, [selectedImage]);
  const { uploadFile, uploadFileState } = useFileUpload({
    onSuccess: ({ url, BaseFileName, fileId }) => {
      setImgURL(url);
    },
    onError: (error) => {
      toast.error("Error al subir la foto");
    },
  });
  const handleSubmit = () => {
    uploadFile({ file: selectedImage });
    closeModal();
    setTimeout(() => {
      setSelectedImage(null);
    }, 300);
  };
  useEffect(() => {
    if (imgURL !== "") {
      handleSubmitPic(imgURL);
    }
  }, [imgURL]);

  return (
    <Modal isOpen={isOpen} style={{ paddingTop: "10vh" }}>
      <ModalBody style={{ padding: "0px" }}>
        <div className="UploadPicHeader">
          <h5 className="font-weight-bold">Sube tu imagen</h5>
          <FontAwesomeIcon
            icon={faTimes}
            color="#9ea0a5"
            style={{ cursor: "pointer" }}
            onClick={handleCancel}
          />
        </div>
        <div>
          <div className="dropZoneMessage">
            <p>El tamaño de tu imagen debe ser menor a 5Mb</p>
          </div>
          {selectedImage ? (
            <>
              <div className="previewProfileImage">
                <div>
                  <img
                    alt="not fount"
                    width={180}
                    src={URL.createObjectURL(selectedImage)}
                  />
                </div>
              </div>
              <div className="selecteImageInfo">
                <FontAwesomeIcon
                  icon={faCamera}
                  size="2x"
                  color="#f37b33"
                  className="ImageIcon"
                />
                <div className="info">
                  <p>
                    {selectedImage?.name?.length > 40
                      ? `${selectedImage?.name?.slice(0, 40)}...`
                      : selectedImage?.name}
                  </p>

                  <span>
                    {String(selectedImage?.size / 1024 ** 2).slice(0, 5)} MB
                  </span>
                </div>
                <FontAwesomeIcon
                  icon={faTimes}
                  size={"1x"}
                  color="#9ea0a5"
                  className="ImageIcon"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setSelectedImage(null);
                    setIsImageValid(false);
                  }}
                />
                {selectedImage?.size / 1024 ** 2 >= 5 ? (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "-25px",
                      left: "0px",
                      color: "rgb(219, 0, 0)",
                    }}
                  >
                    El tamaño de la imagen debe ser menor a 5MB
                  </span>
                ) : (
                  ""
                )}
              </div>
            </>
          ) : (
            <div className="imageDropZoneDash--Parent">
              <input
                type="file"
                name="myImage"
                className="imageDropZoneDash"
                accept="image/*"
                onDrop={(event) => {
                  console.log(event.target.files[0]);
                  setSelectedImage(event.target.files[0]);
                }}
                onChange={(event) => {
                  console.log(event.target.files[0]);
                  setSelectedImage(event.target.files[0]);
                }}
              />

              <FontAwesomeIcon
                icon={faCamera}
                size="4x"
                color="#f37b33"
                className="ImageIcon"
              />
              <div className={"UploadImageLegend"}>
                <FontAwesomeIcon icon={faCloudUploadAlt} color="#9ea0a5" />
                <span>Arrastra o haz clic para cargar</span>
              </div>
            </div>
          )}
        </div>
        <div className="uploadImageFooter">
          <button className="CancelButton" onClick={handleCancel}>
            Cancelar
          </button>
          <button
            className="SaveButton"
            disabled={!isImageValid}
            style={!isImageValid ? { opacity: "0.8" } : {}}
            onClick={handleSubmit}
          >
            Guardar
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default ImageUploade;
